const getCookie = (name) => {
    let value = '; ' + document.cookie;
    let parts = value.split('; ' + name + '=');
    if (parts.length == 2) return parts.pop().split(';').shift();
    return null;
};

const setCookie = (name, value, expiresOn, domain) => {
    document.cookie = name + '=' + value + ';' + (expiresOn ? ('expires=' + expiresOn + ';') : '') + ' path=/' + (domain ? (';domain=' + domain) : '');
};

const clearCookie = (name) => {
    document.cookie = name + '=' + '' + '; path=/';
};

const usercentricsActive = () => (typeof UC_UI !== 'undefined');

const usercentricsClassificationAllowed = (sandhillsClassification) => {
    var consent = true;
    if (sandhillsClassification != sandhillsCookieClassifications.StrictlyNecessary) {
        consent = false;
        var consentCookie = getCookie(consentCookieNames.UserCentrics);
        if (consentCookie) {
            const parsedConsent = JSON.parse(decodeURIComponent(consentCookie));
            consent = (sandhillsClassification == sandhillsCookieClassifications.Advertising && parsedConsent.Advertising) ||
                (sandhillsClassification == sandhillsCookieClassifications.Analytics && parsedConsent.Analytics) ||
                (sandhillsClassification == sandhillsCookieClassifications.Customization && parsedConsent.Customization);
        }
    }

    // Return true since Usercentrics is not loaded
    return consent;
};

const getExpireTimeUTCStringForCookies = (numOfDaysTilExpired) => {
    let now = new Date();
    let time = now.getTime();
    let daystoSeconds = 1000 * 86400 * numOfDaysTilExpired;
    let expireTime = time + daystoSeconds;
    now.setTime(expireTime);
    return now.toUTCString();
};

//Get expiration from specific date time
const getExpirationUTCFromDateTime = (dateTime, numOfDaysTilExpired) => {
    var date = new Date(dateTime);
    var time = date.getTime();
    let daysToSeconds = 1000 * 86400 * numOfDaysTilExpired;
    let expireTime = time + daysToSeconds;
    date.setTime(expireTime);

    return date.toUTCString();
}

// The server-side can't expire cookies for hosted sites (due to response being from a different domain), so we need to check client-side before allowing cookie
const isCookieAllowed = (cookieName, classifications) => {
    try {
        var cookieClassificationMappings = classifications;

        if (cookieClassificationMappings) {
            // Use match method because some cookie names in the dictionary are using regex
            var sandhillsClassification = cookieClassificationMappings.find(x => x.Name === cookieName)?.Classification;

            if (!sandhillsClassification) {
                var regexFiltered = cookieClassificationMappings.filter(m => m.IsRegexPattern);
                if (regexFiltered && regexFiltered.length > 0) {
                    var match = regexFiltered.filter(c => cookieName.match(c.Name.toString(), 'i'));
                    if (match && match.length > 0) {
                        sandhillsClassification = match[0].Classification;
                    }
                };
            }

            if (sandhillsClassification) {
                if (cookieBotActive()) {
                    return cookieBotClassificationAllowed(sandhillsClassification);
                } else if (cookieYesActive()) {
                    return cookieYesClassificationAllowed(sandhillsClassification);
                } else if (osanoActive()) {
                    return osanoClassificationAllowed(sandhillsClassification);
                } else if (usercentricsActive()) {
                    return usercentricsClassificationAllowed(sandhillsClassification);
                } else {
                    return SandhillsConsentClassificationAllowed(sandhillsClassification);
                }
            }
        }
    } catch (error) {
        console.error(error);
    }

    // Allow cookies for now if not in mappings since this method is used to check all saved cookies when consent changes
    // and a lot of the non-mapped cookies will be handled independently by the cookie consent provider scripts
    return true;
}

function getAllSavedCookieNames() {
    var allCookies = document.cookie.split('; ');
    var cookieNames = [];

    for (var i = 0; i < allCookies.length; i++) {
        var cookie = allCookies[i];
        var eqPos = cookie.indexOf('=');
        var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        cookieNames.push(name);
    }

    return cookieNames;
}

const removeUnapprovedCookies = (classifications) => {
    let allCookieNames = getAllSavedCookieNames();

    allCookieNames.forEach(cookieName => {
        var allowedCookie = isCookieAllowed(cookieName, classifications);
        if (!allowedCookie) {
            const rootDomain = getRootDomain();
            const domains = ['', rootDomain, `.${rootDomain}`];
            const expiry = 'Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
            domains.forEach(domain => {
                const domainPart = domain ? `domain=${domain};` : '';
                document.cookie = `${cookieName}=; ${expiry} path=/; ${domainPart}`;
            });
        }
    });
};

const removeUnapprovedLocalStorage = (classifications) => {
    let allLocalStorageKeys = Object.keys(localStorage);

    allLocalStorageKeys.forEach(key => {
        if (!isCookieAllowed(key, classifications)) {
            localStorage.removeItem(key);
        }
    });
};

const removeUnapprovedSessionStorage = (classifications) => {
    let allSessionStorageKeys = Object.keys(sessionStorage);

    allSessionStorageKeys.forEach(key => {
        if (!isCookieAllowed(key, classifications)) {
            sessionStorage.removeItem(key);
        }
    });
};

const setAdvertisingAndAnalyticsCookies = (sandhillsConsent) => {
    var advertisingConsent = getAnalyticsConsentValue(sandhillsConsent.Advertising);
    var analyticsConsent = getAnalyticsConsentValue(sandhillsConsent.Analytics);
    var personalizationConsent = getAnalyticsConsentValue(sandhillsConsent.Customization);

    gtag('consent', 'update', {
        'analytics_storage': analyticsConsent,
        'ad_storage': advertisingConsent,
        'ad_user_data': advertisingConsent,
        'ad_personalization': advertisingConsent,
        'personalization_storage': personalizationConsent,
        'functionality_storage': personalizationConsent,
        'security_storage': personalizationConsent,
    });

    window.uetq.push('consent', 'update', {
        'ad_storage': advertisingConsent
    });
}

const consentCookieNames = {
    CookieBot: 'CookieConsent',
    CookieYes: 'cookieyes-consent',
    OsanoUnencrypted: 'OsanoConsent',
    SandhillsConsent: 'sandhills-consent',
    UserCentrics: 'usercentrics-consent'
};

const setConsentChanged = (sandhillsConsent, RequireInternationalConsent, classifications) => {
    try {
        let cookieBotEnabled = typeof Cookiebot != 'undefined' && typeof Cookiebot.consent != 'undefined';
        let cookieYesEnabled = window.getCkyConsent;
        let osanoEnabled = typeof Osano != 'undefined' && typeof Osano.cm != 'undefined';
        let usercentricsEnabled = usercentricsActive()


        if (cookieBotEnabled || cookieYesEnabled || osanoEnabled || usercentricsEnabled || sandhillsConsent) {
            let removeUnapprovedValues = () => {
                removeUnapprovedCookies(classifications);
                removeUnapprovedLocalStorage(classifications);
                removeUnapprovedSessionStorage(classifications);
            };

            if (usercentricsEnabled) {
                let initialConsentCaptured = false;
                const captureInitialConsent = () => {
                    if (initialConsentCaptured) return;
                    if (getCookie(consentCookieNames.UserCentrics)) {
                        initialConsentCaptured = true;
                        return;
                    }

                    window.__ucCmp?.getConsentDetails().then(consentDetails => {
                        if (initialConsentCaptured) return;
                        setUserCentricsConsentCookie(consentDetails, 365);
                        expireSandhillsConsentCookie();
                        initialConsentCaptured = true;
                    }).catch(e => { console.error('Unable to retrieve initial consent details'); });
                }

                if (typeof window.__ucCmp?.getConsentDetails === 'function') {
                    captureInitialConsent();
                } else {
                    window.addEventListener('UC_UI_INITIALIZED', captureInitialConsent, { once: true });
                }

                window.addEventListener('UC_CONSENT', function (e) {
                    setUserCentricsConsentCookie(e.detail, 365);
                    removeUnapprovedValues();
                    initialConsentCaptured = true;
                }, false);
            } else if (cookieBotEnabled) {
                window.addEventListener('CookiebotOnAccept', function (e) {
                    removeUnapprovedValues();
                }, false);

                window.addEventListener('CookiebotOnDecline', function (e) {
                    removeUnapprovedValues();
                }, false);
            } else if (cookieYesEnabled) {
                document.addEventListener("cookieyes_consent_update", function (eventData) {
                    removeUnapprovedValues();
                });
            } else if (osanoEnabled) {
                Osano.cm.addEventListener('osano-cm-consent-saved', (newConsent) => {
                    // This cookie is set by us and not Osano (we're setting the unencrypted version)
                    // Therefore, we need to make sure it's updated when the consent changes
                    setCookie(consentCookieNames.OsanoUnencrypted, JSON.stringify(newConsent), getExpireTimeUTCStringForCookies(365));
                    removeUnapprovedValues();
                });
            } else if (sandhillsConsent) {
                if (RequireInternationalConsent) {
                    removeUnapprovedValues();
                    setConsentModeSettings(sandhillsConsent);
                }
            }
        }
    } catch (error) {
        console.error(error);
    }
}

const getConsentCookie = (useGuestCookieName, UserCentralTrackingUserID, bUserIsAuthenticated) => {
    var json = getConsentCookieJSON(useGuestCookieName, UserCentralTrackingUserID, bUserIsAuthenticated);
    return json ? JSON.parse(json) : null;
}

const getConsentCookieJSON = (useGuestCookieName, UserCentralTrackingUserID = -1, bUserIsAuthenticated = false) => {
    var value = getCookie(getConsentCookieName(useGuestCookieName))
    if (value && value != '') {
        try {
            return decodeURIComponent(value);
        } catch (err) {
            console.log(err);
        }
    }
    return null;
}

const getConsentCookieName = (useGuestCookieName, UserCentralTrackingUserID, bUserIsAuthenticated) => {
    var cookieName = consentCookieNames.SandhillsConsent;
    if (!useGuestCookieName && bUserIsAuthenticated && UserCentralTrackingUserID > 0) {
        cookieName += '-' + UserCentralTrackingUserID;
    }

    return cookieName;
}

const SetSandhillsConsentCookie = (sandhillsConsent, daysToExpire, centralUserTrackingID) => {
    var cookieName = consentCookieNames.SandhillsConsent;

    if (centralUserTrackingID && parseInt(centralUserTrackingID) > 0) {
        cookieName += '-' + centralUserTrackingID;
    }

    setCookie(cookieName, encodeURIComponent(JSON.stringify(sandhillsConsent)), getExpirationUTCFromDateTime(sandhillsConsent.ActionDateTime, daysToExpire), getRootDomain());
}

const setUserCentricsConsentCookie = (detail, daysToExpire) => {
    if (!detail?.categories) return;

    try {
        const categoryAllowed = (category) => category?.state === 'ALL_ACCEPTED';
        const personalizationCategory = Object.values(detail.categories).find((category) => category?.name === 'Personalized Cookies');

        const cookieName = consentCookieNames.UserCentrics;

        const currentConsent = getCookie(cookieName);
        let consentStatus;

        if (detail.consent) {
            const previousStatus = currentConsent?.ConsentStatus;
            if (detail.consent.type === "EXPLICIT") {
                if (previousStatus === "ACCEPT" || previousStatus === "UPDATE") {
                    consentStatus = "UPDATE";
                } else {
                    consentStatus = "ACCEPT";
                }
            } else {
                consentStatus = "DENY";
            }
        } else {
            consentStatus = currentConsent?.ConsentStatus || null;
        }

        var ucConsent = {
            StrictlyNecessary: true,
            Analytics: categoryAllowed(detail.categories.functional),
            Advertising: categoryAllowed(detail.categories.marketing),
            Customization: categoryAllowed(personalizationCategory),
            ActionDateTime: new Date().toISOString(),
            ConsentStatus: consentStatus,
        };

        var content = encodeURIComponent(JSON.stringify(ucConsent));
        var rootDomain = getRootDomain();
        setCookie(cookieName, content, getExpirationUTCFromDateTime(ucConsent.ActionDateTime, daysToExpire ?? 365), rootDomain);
    } catch (err) {
        console.error(err);
    }
}

const expireSandhillsConsentCookie = () => {
    const oldConsent = getConsentCookie(true);
    if (oldConsent) {
        // expire the logged in cookie
        SetSandhillsConsentCookie(oldConsent, -1, sandhills.TradeSites.React.ComponentProps['userAuthenticatedTrackingID']);
        // expire the guest cookie
        SetSandhillsConsentCookie(oldConsent, -1, null);
    }
}

const getRootDomain = () => {
    const slDs = [
        'co', 'com', 'qc'
    ];

    const parts = window.location.hostname.split('.');
    const len = parts.length;

    if (len <= 2) {
        return window.location.hostname;
    }

    // 2. Check for a three-part root domain (e.g., 'trucklocator.co.uk')
    // We check if the part before the TLD (parts[len - 2]) is a known SLD.
    const secondLast = parts[len - 2];
    const isSLD = slDs.includes(secondLast);

    if (isSLD) {
        // If it's a known SLD (e.g., 'co' in '.co.uk'), we need the last 3 parts.
        return parts.slice(len - 3).join('.');
    } else {
        // Otherwise, it's a standard two-part TLD (e.g., '.com', '.dev', '.app').
        return parts.slice(len - 2).join('.');
    }
}

const setConsentModeSettings = (sandhillsConsent) => {
    try {
        if (sandhillsConsent) {
            const consent = {
                advertisingConsent: getAnalyticsConsentValue(sandhillsConsent.Advertising),
                analyticsConsent: getAnalyticsConsentValue(sandhillsConsent.Analytics),
                personalizationConsent: getAnalyticsConsentValue(sandhillsConsent.Customization),
                securityConsent: getAnalyticsConsentValue(sandhillsConsent.StrictlyNecessary),
            }

            if (typeof consentListeners !== 'undefined' && consentListeners.length > 0) {
                consentListeners.forEach((callback) => {
                    callback(consent);
                });
            }
        }
    } catch (e) {
        console.error(e);
    }
}

const getAnalyticsConsentValue = (consent) => {
    return (typeof consent == 'boolean' && consent == true) ? "granted" : "denied";
}

const setConsentCookie = () => {
    try {
        if (typeof Osano != 'undefined' && typeof Osano.cm != 'undefined' && getCookie(consentCookieNames.OsanoUnencrypted) == null) {
            // Osano consent cookie is encrypted so creating unencrypted version for server-side
            setCookie(consentCookieNames.OsanoUnencrypted, JSON.stringify(Osano.cm.getConsent()), getExpireTimeUTCStringForCookies(365));
        }
    } catch (error) {
        console.error(error);
    }
}

const sandhillsRequest = ({
    url = '',
    method = 'get',
    data = {},
    headers = {},
    disableHeaders = false,
    errorHandling = {
        message: 'An error occurred. Please refresh your page and try again.',
        showDetails: false,
        useConsole: true,
        useAlert: true
    },
    callback = () => { }
} = {}) => {

    // Since cookies can't be passed for cross-domain requests, passing through headers
    if (window?.Overrides?.isHostedSite) {
        let cookieBotCookie = getCookie(consentCookieNames.CookieBot);
        let cookieYesCookie = getCookie(consentCookieNames.CookieYes);
        let osanoCookie = getCookie(consentCookieNames.OsanoUnencrypted);

        if (osanoCookie) {
            headers[consentCookieNames.OsanoUnencrypted] = `${consentCookieNames.OsanoUnencrypted}=${encodeURIComponent(osanoCookie)}`;
        } else if (cookieBotCookie) {
            headers[consentCookieNames.CookieBot] = `${consentCookieNames.CookieBot}=${encodeURIComponent(cookieBotCookie)}`;
        } else if (cookieYesCookie) {
            headers[consentCookieNames.CookieYes] = `${consentCookieNames.CookieYes}=${encodeURIComponent(cookieYesCookie)}`;
        }
    }

    $.ajax({
        url: url,
        method: method,
        data: data,
        headers: disableHeaders ? null : headers,
        success: function (response) {
			callback(response);
        },
        error: function (error) {
            if (errorHandling.useConsole) {
                if (errorHandling.showDetails) {
                    console.error(errorHandling.message, error);
                }
                else {
                    console.error(errorHandling.message);
                }
            }

            if (errorHandling.useAlert) {
                let msg = errorHandling.message;
                if (errorHandling.showDetails) {
                    msg += ' Error Details: ' + error;
                }

                alert(msg);
            }
        }
    });
};

export {
    getCookie,
    getConsentCookie,
    getConsentCookieJSON,
    getConsentCookieName,
    getAllSavedCookieNames,
    setCookie,
    clearCookie,
    getExpireTimeUTCStringForCookies,
    setConsentChanged,
    SetSandhillsConsentCookie,
    consentCookieNames,
    sandhillsRequest
};